import { getConfig } from '@klpkonsern/appconfig';
import { IconName } from '@klp/design/Illustrations';
import { SidebarMenuItem } from '@klp/layout/Sidebar/classes/SidebarMenuItem';
import { generateRoute } from '@klp/routing';

import type { User } from './classes/User';

// Extend AppConfigParameters for this module
declare global {
    interface AppConfigParameters {
        WEBAPP_USER_REGISTER_ENABLE: boolean;
        WEBAPP_INTERCOM_ENABLE: boolean;
        WEBAPP_INTERCOM_APP_ID: string;
    }
}

export const UserModuleName = 'user';

export const UserRoutes = {
    moduleRoute: () => generateRoute([UserModuleName]),
    list: () => generateRoute([UserModuleName]),
    register: () => generateRoute([UserModuleName, 'register']),

    search: () => generateRoute([`${UserModuleName}search`]),
};

export const UserListAccess = (user?: User): boolean => {
    return (user && (user.isAdmin || user.isSuperUser)) || false;
};

export const UserSearchAccess = (user?: User): boolean =>
    (user && (user.isAdmin || user.isSuperUser)) || false;

export const UserEditAccess = (user?: User): boolean =>
    (user && (user.isAdmin || user.isSuperUser)) || false;

export const UserToggleSuperUserAccess = (user?: User): boolean =>
    (user && (user.isAdmin || user.isSuperUser)) || false;

export const UserToggleAdminAccess = (user?: User): boolean =>
    (user && user.isAdmin) || false;

export const UserRegisterAccess = (user?: User): boolean =>
    (getConfig('WEBAPP_USER_REGISTER_ENABLE', false) &&
        user &&
        (user.isAdmin || user.isSuperUser)) ||
    false;

export const UserMenuItems = [
    new SidebarMenuItem({
        route: UserRoutes.list(),
        matchRoute: UserRoutes.moduleRoute(),
        icon: IconName.PROFILE,
        translation: 'listUsers.title',
        access: UserListAccess,
    }),
    new SidebarMenuItem({
        route: UserRoutes.search(),
        matchRoute: UserRoutes.search(),
        icon: IconName.SEARCH,
        translation: 'userSearch.searchTitle',
        access: UserSearchAccess,
    }),
];
